'use strict';

import Api from './abstract'
import { APP_TOKEN_NAME } from '@/config'
import { getQueryString } from '@/utils'

export let RETRIEVE_BUS_LIST = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/buses`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let CREATE_BUS = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/buses`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'multipart/form-data'
  };
  let data = params.data

  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let GET_BUS_INFO = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/buses/`+params.payload.bus_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  // let data = params.payload.bus_id

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let EDIT_BUS = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/buses/`+params.data.bus_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let DELETE_BUS = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/buses/`+params.payload.bus_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };

  return new Api(url, 'delete', successCallback, errorCallback, { headers })
};

// Parent api
export let RETRIEVE_PARENT_LIST = (params, successCallback, errorCallback) => {
  let filter = params.filter || null
  let sort = params.sort || null
  let page = params.page || null
  let url = `${process.env.VUE_APP_API_URL}/admin/parents?${getQueryString(filter, sort, page)}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let CREATE_PARENT = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/parents`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let GET_PARENT_INFO = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/parents/`+params.payload.parent_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let EDIT_PARENT = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/parents/`+params.data.parent_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data.data

  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let DELETE_PARENT = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/parents/`+params.payload.parent_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'delete', successCallback, errorCallback, { headers })
};

// sub driver api
export let CREATE_SUB_DRIVER = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/sub-drivers`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'multipart/form-data'
  };
  let data = params.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let RETRIEVE_SUB_DRIVER_LIST = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/sub-drivers`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let GET_SUB_DRIVER_INFO = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/sub-drivers/`+params.payload.sub_driver_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let EDIT_SUB_DRIVER = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/sub-drivers/`+params.data.sub_driver_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'multipart/form-data'
  };
  let data = params.data.data

  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let DELETE_SUB_DRIVER = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/sub-drivers/`+params.payload.sub_driver_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'delete', successCallback, errorCallback, { headers })
};

// Place api
export let CREATE_PLACE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/places`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let RETRIEVE_PLACE_LIST = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/places`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let GET_PLACE_INFO = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/places/`+params.payload.place_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let EDIT_PLACE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/places/`+params.data.place_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data.data

  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let DELETE_PLACE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/places/`+params.payload.place_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'delete', successCallback, errorCallback, { headers })
};

// Pickup route api
export let CREATE_PICKUP_ROUTE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/pickup-routes`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let RETRIEVE_PICKUP_ROUTE_LIST = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/pickup-routes`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let GET_PICKUP_ROUTE_INFO = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/pickup-routes/`+params.payload.pickup_route_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let EDIT_PICKUP_ROUTE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/pickup-routes/`+params.data.pickup_route_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data.data

  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let DELETE_PICKUP_ROUTE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/pickup-routes/`+params.payload.pickup_route_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'delete', successCallback, errorCallback, { headers })
};

export let REGIST_STUDENT_PICKUP_ROUTE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/pickup-routes/`+params.payload.pickup_route_id+`/students`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.payload.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};


// Student api
export let CREATE_STUDENT = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/students`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'multipart/form-data'
  };
  let data = params.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let RETRIEVE_STUDENT_LIST = (params, successCallback, errorCallback) => {
  let filter = params.filter || null
  let sort = params.sort || null
  let page = params.page || null
  let url = `${process.env.VUE_APP_API_URL}/admin/students?${getQueryString(filter, sort, page)}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let RETRIEVE_MASTER_STUDENT_LIST = (params, successCallback, errorCallback) => {
  let fields = params.fields || '*'
  let url = `${process.env.VUE_APP_API_URL}/admin/master/students?fields=${fields}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let GET_STUDENT_INFO = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/students/`+params.payload.student_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let EDIT_STUDENT = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/students/`+params.data.student_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data.data

  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let DELETE_STUDENT = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/students/`+params.payload.student_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'delete', successCallback, errorCallback, { headers })
};


// drop route api
export let CREATE_DROP_ROUTE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/drop-routes`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let RETRIEVE_DROP_ROUTE_LIST = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/drop-routes`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let GET_DROP_ROUTE_INFO = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/drop-routes/`+params.payload.drop_route_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let EDIT_DROP_ROUTE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/drop-routes/`+params.data.drop_route_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data.data

  return new Api(url, 'put', successCallback, errorCallback, { headers, data })
};

export let DELETE_DROP_ROUTE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/drop-routes/`+params.payload.drop_route_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'delete', successCallback, errorCallback, { headers })
};

export let UPDATE_SCHEDULE_INFO = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/drop-routes/`+params.payload.drop_route_id+`/schedule`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.payload.data

  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};


// class api
export let CREATE_CLASS = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/classes`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let RETRIEVE_BASE_CLASS_LIST = (successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/base-classes`
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
  }

  return new Api(url, 'get', successCallback, errorCallback, { headers })
}

export let RETRIEVE_CLASS_LIST = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/classes`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let GET_CLASS_INFO = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/classes/`+params.payload.class_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let EDIT_CLASS = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/classes/`+params.data.class_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data.data

  return new Api(url, 'put', successCallback, errorCallback, { headers, data })
};

export let DELETE_CLASS = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/classes/`+params.payload.class_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'delete', successCallback, errorCallback, { headers })
};


// Admin notification template api
export let CREATE_ADMIN_NOTIFICATION_TEMPLATE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/admin-notification-templates`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let RETRIEVE_ADMIN_NOTIFICATION_TEMPLATE_LIST = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/admin-notification-templates`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let GET_ADMIN_NOTIFICATION_TEMPLATE_INFO = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/admin-notification-templates/`+params.payload.admin_notification_template_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let EDIT_ADMIN_NOTIFICATION_TEMPLATE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/admin-notification-templates/`+params.data.admin_notification_template_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data.data
  return new Api(url, 'put', successCallback, errorCallback, { headers, data })
};

export let DELETE_ADMIN_NOTIFICATION_TEMPLATE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/admin-notification-templates/`+params.payload.admin_notification_template_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'delete', successCallback, errorCallback, { headers })
};


// parent notification template api
export let CREATE_PARENT_NOTIFICATION_TEMPLATE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/parent-notification-templates`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let RETRIEVE_PARENT_NOTIFICATION_TEMPLATE_LIST = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/parent-notification-templates`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let GET_PARENT_NOTIFICATION_TEMPLATE_INFO = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/parent-notification-templates/`+params.payload.parent_notification_template_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let EDIT_PARENT_NOTIFICATION_TEMPLATE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/parent-notification-templates/`+params.data.parent_notification_template_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data.data
  return new Api(url, 'put', successCallback, errorCallback, { headers, data })
};

export let DELETE_PARENT_NOTIFICATION_TEMPLATE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/parent-notification-templates/`+params.payload.parent_notification_template_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'delete', successCallback, errorCallback, { headers })
};


// bus notification template api
export let CREATE_BUS_NOTIFICATION_CATEGORY = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/bus-notification-categories`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let RETRIEVE_BUS_NOTIFICATION_CATEGORY = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/bus-notification-categories`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let RETRIEVE_BUS_NOTIFICATION_CATEGORY_INFO = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/bus-notification-categories/`+params.data.bus_notification_category_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, {headers})
};

export let UPDATE_BUS_NOTIFICATION_CATEGORY = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/bus-notification-categories/`+params.data.bus_notification_category_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };
  var data = params.data.data
  return new Api(url, 'put', successCallback, errorCallback, {headers, data})
};

export let DELETE_BUS_NOTIFICATION_CATEGORY = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/bus-notification-categories/`+params.payload.bus_notification_category_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'delete', successCallback, errorCallback, { headers })
};

export let CREATE_BUS_NOTIFICATION_TEMPLATE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/bus-notification-templates`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let RETRIEVE_BUS_NOTIFICATION_TEMPLATE_LIST = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/bus-notification-templates`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let GET_BUS_NOTIFICATION_TEMPLATE_INFO = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/bus-notification-templates/`+params.payload.bus_notification_template_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let EDIT_BUS_NOTIFICATION_TEMPLATE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/bus-notification-templates/`+params.data.bus_notification_template_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };
  var data = params.data.data
  return new Api(url, 'put', successCallback, errorCallback, {headers, data})
};

export let DELETE_BUS_NOTIFICATION_TEMPLATE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/bus-notification-templates/`+params.payload.bus_notification_template_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'delete', successCallback, errorCallback, { headers })
};

//notification group

export let CREATE_NOTIFICATION_GROUP = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/notification-groups`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let RETRIEVE_NOTIFICATION_GROUP_LIST = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/notification-groups`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let GET_NOTIFICATION_GROUP_INFO = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/notification-groups/`+params.payload.admin_notification_group_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let UPDATE_ADMIN_NOTIFICATION_GROUP = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/notification-groups/`+params.data.admin_notification_group_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };
  var data = params.data.data
  return new Api(url, 'put', successCallback, errorCallback, {headers, data})
};

export let DELETE_ADMIN_NOTIFICATION_GROUP = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/notification-groups/`+params.payload.admin_notification_group_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'delete', successCallback, errorCallback, { headers })
};


//admin Notification api
export let CREATE_NOTIFICATION = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/admin-notifications`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let RETRIEVE_ADMIN_NOTIFICATION_LIST = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/notification/admin-notifications`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let RETRIEVE_ADMIN_NOTIFICATION_DETAIL = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/notification/admin-notifications/${params.id}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let RETRIEVE_BUS_NOTIFICATION_LIST = (params, successCallback, errorCallback) => {
  let query = getQueryString(params.filter, params.sort, params.page)
  let url = `${process.env.VUE_APP_API_URL}/admin/notification/bus-notifications?${query}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let RETRIEVE_BUS_NOTIFICATION_DETAIL = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/notification/bus-notifications/${params.id}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let RETRIEVE_PARENT_UPDATE_HISTORY_LIST = (params, successCallback, errorCallback) => {
  let query = getQueryString(params.filter, params.sort, params.page)
  let url = `${process.env.VUE_APP_API_URL}/admin/notification/parent-update-notifications?${query}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let RETRIEVE_PARENT_UPDATE_HISTORY_DETAIL = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/notification/parent-update-notifications/${params.id}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let RETRIEVE_PARENT_NOTIFICATION_LIST = (params, successCallback, errorCallback) => {
  let query = getQueryString(params.filter, params.sort, params.page)
  let url = `${process.env.VUE_APP_API_URL}/admin/notification/parent-notifications?${query}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let RETRIEVE_PARENT_NOTIFICATION_DETAIL = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/notification/parent-notifications/${params.id}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let RETRIEVE_STUDENT_LIST_PICKUP_SCHEDULE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/schedule/pickup-route/students`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let RETRIEVE_STUDENT_LIST_DROP_SCHEDULE = (params, successCallback, errorCallback) => {
  let date = params.date
  let url = `${process.env.VUE_APP_API_URL}/admin/schedule/drop-route/students?date=${date}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};
export let RETRIEVE_STUDENT_LIST_PICKUP_SCHEDULE_UPDATE = (params, successCallback, errorCallback) => {
  let date = params.date
  let url = `${process.env.VUE_APP_API_URL}/admin/schedule/pickup-route?date=${date}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let RETRIEVE_MASTER_DATA_SCHEDULE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/schedule/master-data`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let UPDATE_SCHEDULE_DETAIL = ({ data }, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/schedule/schedules`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
  };

  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};


//driver api

export let CREATE_DRIVER = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/drivers`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let RETRIEVE_DRIVER_LIST = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/drivers`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let GET_DRIVER_INFO = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/drivers/`+params.payload.driver_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let EDIT_DRIVER = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/drivers/`+params.data.driver_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };
  var data = params.data.data
  return new Api(url, 'post', successCallback, errorCallback, {headers, data})
};

export let DELETE_DRIVER = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/drivers/`+params.payload.driver_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'delete', successCallback, errorCallback, { headers })
};

export let SEND_MAIL_PARENT = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/parents/send-login-mail/`+params.payload.parent_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let SEND_QR_PARENT = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/parent/mail/authorized-persons`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.payload.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let SEND_MAIL_ALL_PARENT = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/parents-send-login-mail-all`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let SEND_MAIL_AGENT_ALL_PARENT = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/parent/mail/authorized-persons/all`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'post', successCallback, errorCallback, { headers })
};

export let SEND_MAIL_AGENT_PERSON_PARENT = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/parent/mail/authorized-persons`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let RETRIEVE_SETTING_INFO = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/school-settings`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let UPDATE_SCHOOL_SETTINGS = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/school-settings`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  var data = params.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

//admin api

export let CREATE_ADMIN = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/admins`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let RETRIEVE_ADMIN_LIST = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/admins`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let GET_ADMIN_INFO = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/admins/`+params.payload.admin_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let EDIT_ADMIN = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/admins/`+params.data.admin_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };
  var data = params.data.data
  return new Api(url, 'post', successCallback, errorCallback, {headers, data})
};

export let DELETE_ADMIN = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/admins/`+params.payload.admin_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'delete', successCallback, errorCallback, { headers })
};

//attachment api

export let CREATE_ATTACHMENT = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/attachments`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let CREATE_ATTACHMENT_USER = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/attachment_users`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params.attachment_user_file
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let RETRIEVE_ATTACHMENT_LIST = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/attachments`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let RETRIEVE_ATTACHMENT_USER_LIST = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/attachment_users`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let GET_ATTACHMENT_INFO = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/attachments/`+params.payload.attachment_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let EDIT_ATTACHMENT = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/attachments/`+params.data.attachment_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };
  var data = params.data.data
  return new Api(url, 'post', successCallback, errorCallback, {headers, data})
};

export let EDIT_ATTACHMENT_USER = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/attachment_users/`+params.data.attachment_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };
  var data = params.data.attachment_user_file
  return new Api(url, 'post', successCallback, errorCallback, {headers, data})
};

export let DELETE_ATTACHMENT = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/attachments/`+params.payload.attachment_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'delete', successCallback, errorCallback, { headers })
};

export let DELETE_ATTACHMENT_USER = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/attachment_users/`+params.payload.attachment_id;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'delete', successCallback, errorCallback, { headers })
};

export let RETRIEVE_SYSTEM_INFO = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/general/info`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let RETRIEVE_DROP_ROUTE_TIMES = (params, successCallback, errorCallback) => {
  let date = params.date
  let url = `${process.env.VUE_APP_API_URL}/admin/schedule/drop-route/times?date=${date}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let GET_BUS_LAYOUT = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/bus/layouts`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

//get student list for bus
export let GET_STUDENT_LIST_FOR_BUS = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/buses/${params.payload.bus_id}/students`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let UPDATE_BUS_SEAT_MAP = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/buses/${params.bus_id}/seat-map`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };
  let data = params
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let EXPORT_BUS_SEAT_MAP = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/buses/${params.bus_id}/seat-map/export?lang=${params.lang}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
    'content-type': 'application/json'
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let GET_AVAILABLE_PLATE_LIST = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/bus_get_plates`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let GET_PICKUP_ROUTE_ATTACHMENT = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/attachment_users/pickup_route`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let ADMIN_LOGIN = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/admin_login`;
  let headers = {
    Authorization: ``,
  };
  let data = params.login_data

  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let ADMIN_LOGOUT = (successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/admin_logout`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'post', successCallback, errorCallback, { headers })
};

export let PARENT_GET_LIST_ROUTE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/parent-get-list-route`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let RETRIEVE_STUDENT_SCHEDULE_LIST = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/schedule/students?date=${params.date}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let RETRIEVE_CANCEL_LIST = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/cancels?${getQueryString(params.filter, params.sort, params.page)}`
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  }

  return new Api(url, 'get', successCallback, errorCallback, { headers })
}

export let RETRIEVE_CANCEL_DETAIL = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/cancels/${params.id}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
}

export let RETRIEVE_BUS_HISTORY_STUDENT_LIST = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/buses/${params.busId}/history/students?date=${params.date}&route_type=${params.routeType}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
}

export let BUS_HISTORY_STUDENT_CANCEL = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/buses/${params.busId}/history/students/${params.studentId}/cancel`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  let data = {
    route_type: params.routeType,
    date: params.date,
    note: params.note
  }

  return new Api(url, 'patch', successCallback, errorCallback, { headers, data })
}

export let BUS_HISTORY_STUDENT_BOOK = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/buses/${params.busId}/history/students/${params.studentId}/book`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  let data = {
    route_type: params.routeType,
    date: params.date,
    note: params.note
  }

  return new Api(url, 'patch', successCallback, errorCallback, { headers, data })
}

export let BUS_HISTORY_STUDENT_NOTE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/buses/${params.busId}/history/students/${params.studentId}/note`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  }

  let data = {
    route_type: params.routeType,
    date: params.date,
    note: params.note
  }

  return new Api(url, 'patch', successCallback, errorCallback, { headers, data })
}

export let RETRIEVE_DAY_OFF_LIST = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/day-offs`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
}

export let RETRIEVE_DAY_OFF_DETAIL = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/day-offs/${params.id}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
}

export let RETRIEVE_DAY_OFF_DATE_LIST = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/day-off/dates`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
}

export let CREATE_DAY_OFF = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/day-offs`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  let data = {
    title: params.title.trim(),
    type: params.type,
    data: params.data
  }

  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
}

export let UPDATE_DAY_OFF = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/day-offs/${params.id}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  let data = {
    title: params.title.trim(),
    type: params.type,
    data: params.data
  }

  return new Api(url, 'put', successCallback, errorCallback, { headers, data })
}

export let DELETE_DAY_OFF = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/day-offs/${params.id}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'delete', successCallback, errorCallback, { headers })
}

export let IMPORT_STUDENTS = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/import/students`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  let data = params.data

  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
}

export let IMPORT_PLACES = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/import/places`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  let data = params.data

  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
}

export let ADMIN_VERIFY = (successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/verify`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'post', successCallback, errorCallback, { headers })
}

export let UPDATE_LANGUAGE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/language`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  let data = {
    lang: params.lang
  }

  return new Api(url, 'put', successCallback, errorCallback, { headers, data })
}

export let RETRIEVE_SAMPLE_STUDENT_FILE = (successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/import/sample/students`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
}

export let EXPORT_STUDENTS = (successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/export/parents`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
}

export let EXPORT_QR_STUDENTS = (successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/export/qr/students`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
}

export let RETRIEVE_SAMPLE_PLACE_FILE = (successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/import/sample/places`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
}

export let BUS_HISTORY_ADD_STUDENT = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/buses/${params.busId}/history/students`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  let data = {
    route_type: params.routeType,
    student_id: params.studentId,
    date: params.date,
    time: params.time || null
  }

  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
}

export let FORGOT_PASSWORD = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/user/password/forgot?is_admin=1`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  let data = {
    email: params.email
  }

  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
}

export let RESET_PASSWORD = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/user/password/reset?is_admin=1`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  let data = {
    otp: params.otp,
    password: params.password
  }

  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
}

export let EXPORT_PARENTS = (successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/export/parents`
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  }
  let responseType = 'arraybuffer'

  return new Api(url, 'get', successCallback, errorCallback, { headers, responseType })
}

export let EXPORT_CANCELS = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/export/cancels?date=${params.date}&lang=${params.lang}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };
  let responseType = 'arraybuffer'

  return new Api(url, 'get', successCallback, errorCallback, { headers, responseType })
}

export let RETRIEVE_ADMIN_NOTIFICATION_MASTER_DATA = (successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/notification/master-data`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
}

export let CREATE_CANCEL = (data, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/cancels`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
}



export let DELETE_CANCEL = (id, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/cancels/${id}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'delete', successCallback, errorCallback, { headers })
}

export let UPDATE_ATTACHMENT_STATUS = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/attachment_users/${params.id}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };
  let data = params.data || null

  return new Api(url, 'put', successCallback, errorCallback, { headers, data })
}

export let RETRIEVE_ADMIN_NOTIFICATION_PARENT_LIST = (successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/notification/parents`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
}

export let RETRIEVE_MASTER_STUDENT_LIST_NO_FILTER = (successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/master/students`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
}

export let RETRIEVE_TEMPLATE_LIST = (params, successCallback, errorCallback) => {
  let filter = params.filter || null
  let sort = params.sort || null
  let page = params.page || null
  let url = `${process.env.VUE_APP_API_URL}/admin/schedule/templates?${getQueryString(filter, sort, page)}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let CREATE_TEMPLATE = (data, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/schedule/templates`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};

export let UPDATE_TEMPLATE = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/schedule/templates/${params.id}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };
  let data = params.data
  return new Api(url, 'put', successCallback, errorCallback, { headers, data })
};


export let GET_DETAIL_TEMPLATE = (data, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/schedule/templates/${data.id}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
};


export let DELETE_TEMPLATE = (data, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/schedule/templates/${data.id}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };
  return new Api(url, 'delete', successCallback, errorCallback, { headers })
}


export let GET_MASTER_TEMPLATE = (data, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/master/schedule/templates`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };
  return new Api(url, 'get', successCallback, errorCallback, { headers })
}

export let RETRIEVE_AUTHORIZED_PERSON_NOTIFICATION_LIST = (params, successCallback, errorCallback) => {
  let query = getQueryString(params.filter, params.sort, params.page)
  let url = `${process.env.VUE_APP_API_URL}/admin/notification/authorized-persons?${query}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let RETRIEVE_AUTHORIZED_PERSON_NOTIFICATION_DETAIL = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/notification/authorized-persons/${params.id}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};



export let RETRIEVE_SCHEDULE_TEMPLATE_STUDENT_LIST = (params, successCallback, errorCallback) => {
  let filter = params.filter || null
  let page = params.page || null
  let url = `${process.env.VUE_APP_API_URL}/admin/schedule/template/students?${getQueryString(filter, null, page)}`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};


export let RETRIEVE_SCHEDULE_TEMPLATE_STUDENT_LIST_ALL = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/schedule/template/students/all`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
  };

  return new Api(url, 'get', successCallback, errorCallback, { headers })
};
